export default "__VITE_ASSET__e8d058b7__"